// extracted by mini-css-extract-plugin
module.exports = {"container":"StreamerWidgets_container_2Uu_H","header":"StreamerWidgets_header_PzV6k","navigation":"StreamerWidgets_navigation_1F8B_"};